import { render } from "./FactoriesComponent.vue?vue&type=template&id=2b221c04&scoped=true"
import script from "./FactoriesComponent.vue?vue&type=script&lang=js"
export * from "./FactoriesComponent.vue?vue&type=script&lang=js"

import "./FactoriesComponent.vue?vue&type=style&index=0&id=2b221c04&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b221c04"]])

export default __exports__